import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Marked } from 'marked';
import {
  MAXX_ERROR_NON_RETRYABLE,
  MAXX_ERROR_RETRYABLE,
  MaxxAnalysisRowState,
} from '../../services/maxx-test-analysis.model';

// Mirrors the chat widget's TextBlock: remark-breaks + remark-gfm, http links open in a new tab,
// anything else renders as plain text, so the same report behaves the same in both views.
const reportMarkdown = new Marked({ async: false, breaks: true, gfm: true });
reportMarkdown.use({
  renderer: {
    link(token) {
      const text = this.parser.parseInline(token.tokens);
      if (!token.href.startsWith('http')) {
        return text;
      }
      const title = token.title ? ` title="${token.title}"` : '';
      return `<a href="${token.href}"${title} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
});

@Component({
  selector: 'maxx-analysis-panel',
  templateUrl: './maxx-analysis-panel.component.html',
  styleUrls: ['./maxx-analysis-panel.component.scss'],
  standalone: false,
})
export class MaxxAnalysisPanelComponent implements OnChanges {
  @Input({ required: true }) state: MaxxAnalysisRowState;
  @Input({ required: true }) panelId: string;
  @Input({ required: true }) testName: string;

  @Output() collapse = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
  @Output() continueInChat = new EventEmitter<number>();

  readonly retryLabel = 'Try again';

  errorMessage = MAXX_ERROR_RETRYABLE;
  answerHtml = '';

  ngOnChanges(): void {
    this.errorMessage =
      this.state.errorMessage ?? (this.state.errorRetryable ? MAXX_ERROR_RETRYABLE : MAXX_ERROR_NON_RETRYABLE);

    this.answerHtml = this.state.answer ? (reportMarkdown.parse(this.state.answer, { async: false }) as string) : '';
  }
}
